import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Hero from '@/pages/home/components/Hero';
import TimelineSection from '@/pages/home/components/TimelineSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FactsSection from '@/pages/home/components/FactsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <SiteHeader />
      <main>
        <Hero />
        <TimelineSection />
        <TopicsSection />
        <FactsSection />
        <UpdatesSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}